export const widgetEvents = {
  iframeResize: 'IFRAME-RESIZE',
  venueDataSet: 'VENUE-DATA-SET',
  eventSelected: 'EVENT-SELECTED',
  inventorySelected: 'INVENTORY-SELECTED',
  checkoutFlowStarted: 'CHECKOUT-FLOW-STARTED',
  stripeCheckoutRedirect: 'STRIPE-CHECKOUT-REDIRECT',
  guestlistModalOpen: 'GUESTLIST-MODAL-OPEN',
  reservationModalOpen: 'RESERVATION-MODAL-OPEN',
  tlproIframeUpdate: 'TABLELIST_IFRAME_MESSAGE',
} as const

export const widgetEventTypes = {
  dimensionsUpdated: 'IFRAME_DIMENSIONS_UPDATED',
} as const

export const widgetAttributionTypes = {
  member: 'MEMBER',
  relationship: 'RELATIONSHIP',
  custom: 'CUSTOM',
  tablelist: 'TABLELIST',
  widget: 'WIDGET',
  reservationRequestForm: 'RESERVATION_REQUEST_FORM',
  fastPass: 'FAST_PASS',
  import: 'IMPORT',
  none: 'NONE',
  walkup: 'WALKUP',
} as const

export const widgetAttribution = {
  reservationForm: widgetAttributionTypes.reservationRequestForm,
  guestlistForm: widgetAttributionTypes.reservationRequestForm,

  checkoutModal: widgetAttributionTypes.widget,
  inventoryList: widgetAttributionTypes.widget,
  inventoryMap: widgetAttributionTypes.widget,
  eventList: widgetAttributionTypes.widget,
  eventGrid: widgetAttributionTypes.widget,
  eventCalendar: widgetAttributionTypes.widget,
  eventCarousel: widgetAttributionTypes.widget,

  widget: widgetAttributionTypes.widget,
} as const

export const inventoryWidgetAttributions = new Set<string>([
  widgetAttribution.inventoryMap,
  widgetAttribution.inventoryList,
  widgetAttribution.widget,
])

export type WidgetEvent = (typeof widgetEvents)[keyof typeof widgetEvents]
export type WidgetEventType =
  (typeof widgetEventTypes)[keyof typeof widgetEventTypes]

export type WidgetAttributionType =
  (typeof widgetAttributionTypes)[keyof typeof widgetAttributionTypes]
